import { CallQueueState } from "../interfaces/queue"
import { VoiceMailState } from "../interfaces/voiceMail"
import { Types } from "../types"
import { CallQueueActions } from "../types/Queues/actionsType"
import { VoiceMailActions } from "../types/voiceMail/actionTypes"


const initialState: VoiceMailState = {
    getVoiceMailsPending: false,
    getVoiceMailsSuccess: false,
    getVoiceMailsError: '',
    data: {},
    IsLastPage: false,

    setHeardByVoicEmailIdPending: false,
    setHeardByVoicEmailIdSuccess: false,
    setHeardByVoicEmailIdError: '',


    moveToTrashVoiceMailPending: false,
    moveToTrashVoiceMailSuccess: false,
    moveToTrashVoiceMailError: '',

    getAudioFileVoiceMailPending: false,
    getAudioFileVoiceMailSuccess: false,
    getAudioFileVoiceMailError: '',
    url: '',

    getVoicemailBoxesPending: false,
    getVoicemailBoxesSuccess: false,
    getVoicemailBoxesError: '',
    list: []


}


const voiceMailReducer = (state = initialState, action: VoiceMailActions) => {

    switch (action.type) {
        case Types.GET_VOICE_MAIL_REQUEST:
            return {
                ...state,
                getVoiceMailsPending: true,
                getVoiceMailsSuccess: false,
                getVoiceMailsError: '',
                IsLastPage: false,
                data: {}
            }

        case Types.GET_VOICE_MAIL_SUCCESS:
            return {
                ...state,
                getVoiceMailsPending: false,
                getVoiceMailsSuccess: true,
                getVoiceMailsError: '',
                data: action.payload.params.Voicemails,
                IsLastPage: action.payload.params.IsLastPage
            }

        case Types.GET_VOICE_MAIL_ERROR:
            return {
                ...state,
                getVoiceMailsPending: false,
                getVoiceMailsSuccess: false,
                getVoiceMailsError: action.payload,
                data: {},
                IsLastPage: false
            }
        //******************************************************************************** */
        case Types.SET_HEARD_BY_VOICE_EMAIL_ID_REQUEST:
            return {
                ...state,
                setHeardByVoicEmailIdPending: true,
                setHeardByVoicEmailIdSuccess: false,
                setHeardByVoicEmailIdError: ''
            }

        case Types.SET_HEARD_BY_VOICE_EMAIL_ID_SUCCESS:
            return {
                ...state,
                setHeardByVoicEmailIdPending: false,
                setHeardByVoicEmailIdSuccess: true,
                setHeardByVoicEmailIdError: ''
            }

        case Types.SET_HEARD_BY_VOICE_EMAIL_ID_ERROR:
            return {
                ...state,
                setHeardByVoicEmailIdPending: false,
                setHeardByVoicEmailIdSuccess: false,
                setHeardByVoicEmailIdError: action.payload
            }
        //********************************************************************************* */
        case Types.MOVE_TO_TRASH_VOICE_EMAIL_REQUEST:
            return {
                ...state,
                moveToTrashVoiceMailPending: true,
                moveToTrashVoiceMailSuccess: false,
                moveToTrashVoiceMailError: '',
            }

        case Types.MOVE_TO_TRASH_VOICE_EMAIL_SUCCESS:
            return {
                ...state,
                moveToTrashVoiceMailPending: false,
                moveToTrashVoiceMailSuccess: true,
                moveToTrashVoiceMailError: '',
            }

        case Types.MOVE_TO_TRASH_VOICE_EMAIL_ERROR:
            return {
                ...state,
                moveToTrashVoiceMailPending: false,
                moveToTrashVoiceMailSuccess: false,
                moveToTrashVoiceMailError: action.payload,
            }
        //****************************************************************************************** */
        case Types.GET_AUDIO_FILE_VOICE_MAIL_REQUEST:
            return {
                ...state,
                getAudioFileVoiceMailPending: true,
                getAudioFileVoiceMailSuccess: false,
                getAudioFileVoiceMailError: '',
                url: ''
            }

        case Types.GET_AUDIO_FILE_VOICE_MAIL_SUCCESS:
            return {
                ...state,
                getAudioFileVoiceMailPending: false,
                getAudioFileVoiceMailSuccess: true,
                getAudioFileVoiceMailError: '',
                url: action.payload.params
            }

        case Types.GET_AUDIO_FILE_VOICE_MAIL_ERROR:
            return {
                ...state,
                getAudioFileVoiceMailPending: false,
                getAudioFileVoiceMailSuccess: false,
                getAudioFileVoiceMailError: action.payload,
                url: ''
            }
        //******************************************************************************************** */
        case Types.GET_VOICE_MAIL_BOX_REQUEST:
            return {
                ...state,
                getVoicemailBoxesPending: true,
                getVoicemailBoxesSuccess: false,
                getVoicemailBoxesError: '',
                list: []
            }

        case Types.GET_VOICE_MAIL_BOX_SUCCESS:
            return {
                ...state,
                getVoicemailBoxesPending: false,
                getVoicemailBoxesSuccess: true,
                getVoicemailBoxesError: '',
                list: action.payload.params
            }

        case Types.GET_VOICE_MAIL_BOX_ERROR:
            return {
                ...state,
                getVoicemailBoxesPending: false,
                getVoicemailBoxesSuccess: false,
                getVoicemailBoxesError: '',
                list: []
            }


        case Types.GET_LINE_VOICE_MAIL_URL_REQUEST:
            return {
                ...state,
                getVoicemailUrlPending: true,
                getVoicemailUrlSuccess: false,
                getVoicemailUrlError: '',
                lineVoiceMailUrl: null
            }

        case Types.GET_LINE_VOICE_MAIL_URL_SUCCESS:
            return {
                ...state,
                getVoicemailUrlPending: false,
                lineVoiceMailUrl: action.payload.params
            }

        case Types.GET_LINE_VOICE_MAIL_URL_ERROR:
            return {
                ...state,
                getVoicemailUrlPending: false,
                getVoicemailUrlError: '',
            }


        case Types.POST_LINE_VOICE_MAIL_URL_REQUEST:
            return {
                ...state,
                postVoicemailUrlPending: true,
                postVoicemailUrlSuccess: false,
                postVoicemailUrlError: '',
            }

        case Types.POST_LINE_VOICE_MAIL_URL_SUCCESS:
            return {
                ...state,
                postVoicemailUrlPending: false,
                postVoicemailUrlSuccess: true
            }

        case Types.POST_LINE_VOICE_MAIL_URL_ERROR:
            return {
                ...state,
                postVoicemailUrlPending: false,
                postVoicemailUrlError: '',
            }


        //************************************************************************************* */


        case Types.RESET_MOVE_TO_TRASH_VOICE_EMAIL:
            return {
                ...state,
                moveToTrashPending: false,
                moveToTrashSuccess: false,
                moveToTrashError: '',
            }
        case Types.RESET_SET_HEARD_BY_VOICE_EMAIL_ID:
            return {
                ...state,
                setHeardByVoicEmailIdPending: false,
                setHeardByVoicEmailIdSuccess: false,
                setHeardByVoicEmailIdError: ''
            }
        case Types.RESET_AUDIO_FILE_VOICE_MAIL:
            return {
                ...state,
                getAudioFilePending: false,
                getAudioFileSuccess: false,
                getAudioFileError: ''
            }



        default:
            return {
                ...state,
            }
    }
}

export default voiceMailReducer